export function portalAccessKey(input: {
	isPortalAdmin: boolean;
	canWorkRequests: boolean;
	tags: string[];
}): "accessAdmin" | "accessRequests" | "accessTillOnly" | "accessNone" {
	if (input.isPortalAdmin) {
		return "accessAdmin";
	}
	if (input.canWorkRequests) {
		return "accessRequests";
	}
	if (input.tags.includes("BONUS_REDEMPTION")) {
		return "accessTillOnly";
	}
	return "accessNone";
}
